import type { RoomState } from "../types";
import { PlayerAvatar } from "./PlayerAvatar";

interface Props {
  room: RoomState;
  you: string;
  onPlayAgain: () => void;
}

export function GameOver({ room, you, onPlayAgain }: Props) {
  const standings = [...room.players].sort((a, b) => b.score - a.score);
  const champ = standings[0];
  const isHost = room.hostId === you;

  return (
    <div className="gameover">
      <div className="gameover-head">
        <h1>The cattery has spoken</h1>
        {champ && (
          <p className="muted">
            <b>{champ.name}</b> walks away with the crown.
          </p>
        )}
      </div>
      <ol className="podium">
        {standings.slice(0, 3).map((p, i) => (
          <li key={p.id} className={`podium-${i + 1}`}>
            <PlayerAvatar player={p} size={i === 0 ? 88 : 64} />
            <div className="podium-name">{p.name}</div>
            <div className="podium-score">{p.score}</div>
            <div className="podium-medal">{["gold", "silver", "bronze"][i]}</div>
          </li>
        ))}
      </ol>
      {standings.length > 3 && (
        <ul className="rest">
          {standings.slice(3).map((p, i) => (
            <li key={p.id}>
              <span className="muted">#{i + 4}</span>
              <PlayerAvatar player={p} size={28} />
              <span>{p.name}</span>
              <span className="standing-score">{p.score}</span>
            </li>
          ))}
        </ul>
      )}
      {isHost ? (
        <button className="primary big" onClick={onPlayAgain}>
          Run it back
        </button>
      ) : (
        <p className="muted small">Host can start another game.</p>
      )}
    </div>
  );
}
